export default "/_next/static/images/Process_Step_1-28f0d9716a7e31fbb8bc20671a411734.jpg";